"use strict";
/**
 * @fileoverview API query parameters interface for getting customers
 * Defines filtering, sorting, and pagination parameters
 */
Object.defineProperty(exports, "__esModule", { value: true });
